module.exports = __webpack_public_path__ + "static/media/Innovating Teaching Learning on IoT 2024.b9825530.pdf";